// extracted by mini-css-extract-plugin
export default {"container":"CurrentPost_container__4aDsQ","post_container":"CurrentPost_post_container__lOHiF","header":"CurrentPost_header__-RuAu","text_body":"CurrentPost_text_body__VRl5e"};